import React, { useState, useEffect, useRef } from 'react';
import './style.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Blocka from './blockA';
import Blockb from './blockB';
import Blockbc from './blockBC';
import Blockc from './blockC';
import Blockd from './blockD';
import Blocke from './blockE';
import Blockf from './blockF';
import { scrollToAnchor } from '../../utils/scrollUtils';

const VALID_TABS = ['blocka', 'blockb', 'blockbc', 'blockc', 'blockd', 'blocke', 'blockf'];

const ExhibitsPage = ({ language }) => {
    const textContent = {
        en: {
            pageTitle: 'Main Attractions',
            HomePage: 'Home',
            tabs: {
                blocka: 'Block A',
                blockb: 'Block B',
                blockbc: 'Block BC',
                blockc: 'Block C',
                blockd: 'Block D',
                blocke: 'Block E',
                blockf: 'Block F',
            },
        },
        hi: {
            pageTitle: 'मुख्य आकर्षण',
            HomePage: 'मुख्य पृष्ठ',
            tabs: {
                blocka: 'खंड ए',
                blockb: 'खंड बी',
                blockbc: 'खंड बीसी',
                blockc: 'खंड सी',
                blockd: 'खंड डी',
                blocke: 'खंड ई',
                blockf: 'खंड एफ',
            },
        },
    };

    const location = useLocation();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('blocka');
    const pendingAnchorRef = useRef(null);

    useEffect(() => {
        const target = location.state?.searchTarget;
        if (!target) return;

        const { tab, anchor } = target;

        if (tab && VALID_TABS.includes(tab)) {
            if (tab !== activeTab) {
                if (anchor) pendingAnchorRef.current = anchor;
                setActiveTab(tab);
            } else {
                if (anchor) setTimeout(() => scrollToAnchor(anchor), 80);
            }
        } else if (anchor) {
            setTimeout(() => scrollToAnchor(anchor), 80);
        }

        navigate(location.pathname, { replace: true, state: {} });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.state]);

    useEffect(() => {
        if (!pendingAnchorRef.current) return;
        const anchor = pendingAnchorRef.current;
        pendingAnchorRef.current = null;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                scrollToAnchor(anchor);
            });
        });
    }, [activeTab]);

  return (
    <>
      <div
        className="inner-pages-head"
        style={{ backgroundImage: `url('images/about-header-bg.jpg')` }}
      >
        <div className="container">
          <div className="title_and_breadcrumbs">
            <h1>{textContent[language].pageTitle}</h1>
            <ul>
              <li>
                <Link to="/">{textContent[language].HomePage}</Link>
              </li>
              <span></span>
              <li>{textContent[language].pageTitle}</li>
            </ul>
          </div>
          <div className="banner-logo">
            <img src="images/mahabharat-logo.svg" alt="" />
          </div>
        </div>
      </div>

            <div className="page_content_wrapper main_attractions_tabs">
                <div className="container">
                    <div className="content_wrapper">
                        <Tabs
                            activeKey={activeTab}
                            onSelect={(k) => k && setActiveTab(k)}
                            id="main-attractions-tabs"
                        >
                            <Tab eventKey="blocka" title={textContent[language].tabs.blocka}>
                                <Blocka language={language} />
                            </Tab>
                            <Tab eventKey="blockb" title={textContent[language].tabs.blockb}>
                                <Blockb language={language} />
                            </Tab>
                            <Tab eventKey="blockbc" title={textContent[language].tabs.blockbc}>
                                <Blockbc language={language} />
                            </Tab>
                            <Tab eventKey="blockc" title={textContent[language].tabs.blockc}>
                                <Blockc language={language} />
                            </Tab>
                            <Tab eventKey="blockd" title={textContent[language].tabs.blockd}>
                                <Blockd language={language} />
                            </Tab>
                            <Tab eventKey="blocke" title={textContent[language].tabs.blocke}>
                                <Blocke language={language} />
                            </Tab>
                            <Tab eventKey="blockf" title={textContent[language].tabs.blockf}>
                                <Blockf language={language} />
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExhibitsPage;
